import React, { useEffect, useState } from "react";
import "./Preloader.css";

const Preloader = ({ onFinish }) => {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHide(true);

      setTimeout(() => {
        onFinish?.();
      }, 300);

    }, 1200);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`preloader ${hide ? "preloader--hide" : ""}`}>
      <div className="preloader__glow"></div>

      <div className="preloader__content">
        <h1 className="preloader__title">NEBU</h1>

        <div className="preloader__line"></div>

        <p className="preloader__subtitle">
          Gold & Jewelry Expo
        </p>
      </div>
    </div>
  );
};

export default Preloader;